module.exports = __webpack_public_path__ + "static/img/2023_9_8_4.ec1644bb.ec1644b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/2023_9_8_4.ec1644bb.png
// module id = WDk5
// module chunks = 0